define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/GaFeeStateGov", "lodash.debounce", "../services"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, GaFeeStateGov_1, lodash_debounce_1, services_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GaFeeSchedule = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class GaFeeSchedule extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AuthorityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuthorityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NoDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NoDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FencingStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FencingStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lotplan", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanAreaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanValuation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LotplanValuationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RatingPercentage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RatingPercentageError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RentalPercentage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RentalPercentageError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RatingFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RatingFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RentalFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RentalFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AnnualFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AnnualFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ProrataFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ProrataFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Fee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OverrideFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OverrideFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OverrideReason", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OverrideReasonError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MiscConditions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MiscConditionsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConfigIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaFeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedGaFeeStateGov", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GaFeeStateGovError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "GrazingAuthPermit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onLotPlanChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, GaFeeSchedule.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.GrazingAuthPermit = parent;
            this.AuthorityId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.GaFeeStateGov = [];
        }
        onRead(entity, parent) {
            this.GrazingAuthPermit = parent;
            this.GaFeeStateGov = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AuthorityId = (0, EntityUtil_1.toInt)(entity.AuthorityId);
            a.StartDt = b.StartDt;
            a.EndDt = b.EndDt;
            a.NoDays = (0, EntityUtil_1.toInt)(entity.NoDays);
            a.FencingStatus = b.FencingStatus;
            a.Lotplan = b.Lotplan;
            a.LotplanArea = (0, EntityUtil_1.toFloat)(entity.LotplanArea);
            a.LotplanValuation = (0, EntityUtil_1.toFloat)(entity.LotplanValuation);
            a.RatingPercentage = (0, EntityUtil_1.toFloat)(entity.RatingPercentage);
            a.RentalPercentage = (0, EntityUtil_1.toFloat)(entity.RentalPercentage);
            a.RatingFee = (0, EntityUtil_1.toFloat)(entity.RatingFee);
            a.RentalFee = (0, EntityUtil_1.toFloat)(entity.RentalFee);
            a.AnnualFee = (0, EntityUtil_1.toFloat)(entity.AnnualFee);
            a.ProrataFee = (0, EntityUtil_1.toFloat)(entity.ProrataFee);
            a.Fee = (0, EntityUtil_1.toFloat)(entity.Fee);
            a.FeeStateGov = (0, EntityUtil_1.toFloat)(entity.FeeStateGov);
            a.OverrideFee = (0, EntityUtil_1.toFloat)(entity.OverrideFee);
            a.OverrideReason = b.OverrideReason;
            a.MiscConditions = b.MiscConditions;
            a.ConfigId = (0, EntityUtil_1.toInt)(entity.ConfigId);
            a.GaFeeStateGov = this.mergeArray(a.GaFeeStateGov, b.GaFeeStateGov, GaFeeStateGov_1.GaFeeStateGov);
            a.SelectedGaFeeStateGov = a.SelectedGaFeeStateGov && a.GaFeeStateGov.find(x => x.Id == a.SelectedGaFeeStateGov.Id) ? a.SelectedGaFeeStateGov : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.onLotPlanChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 3000);
            this.addChangeEventAction("Lotplan", this.onLotPlanChangeBatchFn.bind(this));
            this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 1000);
            this.addChangeEventAction("RatingPercentage", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("RentalPercentage", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("OverrideFee", this.onChangeBatchFn.bind(this));
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, GaFeeSchedule.AliasName);
            this.reset();
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqDate(validationState, "StartDt", "Start Date");
                this.validateReqDate(validationState, "EndDt", "End Date");
                this.validateReqNumber(validationState, "NoDays", "Number of Days");
                this.validateReqString(validationState, "FencingStatus", "Fencing Status");
                this.validateReqString(validationState, "Lotplan", "Lot Plan");
                this.validateReqNumber(validationState, "RatingPercentage", "Rating Percentage", { isPc: true });
                this.validateReqNumber(validationState, "RentalPercentage", "Rental Percentage", { isPc: true });
                this.validateReqNumber(validationState, "ConfigId", "Configuration Id");
            }
            let gaConfig = services_1.AppConfigManager.InstanceSync.ActiveConfiguration().Configuration.GrazingAuthorityPermit;
            if (!gaConfig) {
                console.error("GA configuration not found");
                return;
            }
            if (this.RatingPercentage < gaConfig.RatingFeeRule.MinPc || this.RatingPercentage > gaConfig.RatingFeeRule.MaxPc) {
                this.RatingPercentageError = "Invalid Rating %. Valid values are between " + (gaConfig.RatingFeeRule.MinPc * 100) + "% - " + (gaConfig.RatingFeeRule.MaxPc * 100) + "%";
                validationState.addError(this.RatingPercentageError);
            }
            else {
                this.RatingPercentageError = "";
            }
            if (this.RentalPercentage < gaConfig.RentalFeeRule.MinPc || this.RentalPercentage > gaConfig.RentalFeeRule.MaxPc) {
                this.RentalPercentageError = "Invalid Rental %. Valid values are between " + (gaConfig.RentalFeeRule.MinPc * 100) + "% - " + (gaConfig.RentalFeeRule.MaxPc * 100) + "%";
                validationState.addError(this.RentalPercentageError);
            }
            else {
                this.RentalPercentageError = "";
            }
            if (!isNaN(this.OverrideFee) && this.OverrideFee != this.Fee && this.OverrideFee > 0 && (this.OverrideReason == null || this.OverrideReason.length == 0)) {
                this.OverrideReasonError = "If an Override Fee is specified, then a reason must be given";
                validationState.addError(this.OverrideReasonError);
            }
            else {
                this.RentalPercentageError = "";
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqDate(validationState, "StartDt", "Start Date");
                this.validateReqDate(validationState, "EndDt", "End Date");
                this.validateReqNumber(validationState, "NoDays", "Number of Days");
                this.validateReqString(validationState, "FencingStatus", "Fencing Status");
                this.validateReqString(validationState, "Lotplan", "Lot Plan");
                this.validateReqNumber(validationState, "RatingPercentage", "Rating Percentage", { precision: 2 });
                this.validateReqNumber(validationState, "RentalPercentage", "Rental Percentage", { precision: 2 });
                this.validateReqNumber(validationState, "ConfigId", "Configuration Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.GaFeeStateGov) {
                for (let x of this.GaFeeStateGov) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AuthorityId: this.AuthorityId,
                StartDt: this.StartDt,
                EndDt: this.EndDt,
                NoDays: this.NoDays,
                FencingStatus: this.FencingStatus,
                Lotplan: this.Lotplan,
                LotplanArea: this.LotplanArea,
                LotplanValuation: this.LotplanValuation,
                RatingPercentage: this.RatingPercentage,
                RentalPercentage: this.RentalPercentage,
                RatingFee: this.RatingFee,
                RentalFee: this.RentalFee,
                AnnualFee: this.AnnualFee,
                ProrataFee: this.ProrataFee,
                Fee: this.Fee,
                FeeStateGov: this.FeeStateGov,
                OverrideFee: this.OverrideFee,
                OverrideReason: this.OverrideReason,
                MiscConditions: this.MiscConditions,
                ConfigId: this.ConfigId,
                GaFeeStateGov: this.GaFeeStateGov.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onChange(change) {
            if (change.name = "Lotplan") {
                this.updateLotPlanValuation(change);
            }
            if (this.GrazingAuthPermit) {
                this.GrazingAuthPermit.onChange(change);
            }
        }
        updateLotPlanValuation(change) {
            const { oldVal } = (0, EntityUtil_1.parseChangeEvent)(change);
            if (change && this.Lotplan != oldVal) {
                services_1.SrmsServiceManager.Instance.PermitApplication.getLotPlanQvasEvaluation(this.Lotplan).then(res => {
                    if (res) {
                        this.LotplanValuation = res.LotplanValuation;
                        this.LotplanArea = res.LotplanArea;
                        this.GrazingAuthPermit.calculateFees();
                    }
                    else {
                        let err = new services_1.ServiceError(`QVAS does not contain a Lot Plan Valuation for ${this.Lotplan}. Please enter a valid Lot Plan and try again`);
                        services_1.EventManager.Instance.emitError(err);
                    }
                });
            }
        }
    }
    exports.GaFeeSchedule = GaFeeSchedule;
    Object.defineProperty(GaFeeSchedule, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "GaFeeSchedule"
    });
    Object.defineProperty(GaFeeSchedule, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Grazing Authority Fee Schedule"
    });
    Object.defineProperty(GaFeeSchedule, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AuthorityId", "StartDt", "EndDt", "NoDays", "FencingStatus", "Lotplan", "LotplanArea", "LotplanValuation", "RatingPercentage", "RentalPercentage", "RatingFee", "RentalFee", "AnnualFee", "ProrataFee", "Fee", "FeeStateGov", "OverrideFee", "OverrideReason", "MiscConditions", "ConfigId"]
    });
    Object.defineProperty(GaFeeSchedule, "AuthorityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "NoDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "FencingStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(GaFeeSchedule, "FencingStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "FencingStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "LotplanLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(GaFeeSchedule, "LotplanReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "LotplanAreaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "LotplanValuationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "RatingPercentageReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "RentalPercentageReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(GaFeeSchedule, "RatingFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "RentalFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "AnnualFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "ProrataFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "FeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "FeeStateGovReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "OverrideFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "OverrideReasonLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(GaFeeSchedule, "OverrideReasonReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "MiscConditionsLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(GaFeeSchedule, "MiscConditionsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(GaFeeSchedule, "ConfigIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "AuthorityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "AuthorityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "NoDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "NoDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "FencingStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "FencingStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "Lotplan", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "LotplanError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "LotplanArea", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "LotplanAreaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "LotplanValuation", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "LotplanValuationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RatingPercentage", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RatingPercentageError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RentalPercentage", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RentalPercentageError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RatingFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RatingFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RentalFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "RentalFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "AnnualFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "AnnualFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "ProrataFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "ProrataFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "Fee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "FeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "FeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "FeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "OverrideFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "OverrideFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "OverrideReason", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "OverrideReasonError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "MiscConditions", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "MiscConditionsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "ConfigId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "ConfigIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "GaFeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "SelectedGaFeeStateGov", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "GaFeeStateGovError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], GaFeeSchedule.prototype, "GrazingAuthPermit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeSchedule.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeSchedule.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeSchedule.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeSchedule.prototype, "onChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], GaFeeSchedule.prototype, "updateLotPlanValuation", null);
});
